export const _en = {
    addButton: {
        label: "Add a new profile"
    },
    toggleDeleted: {
        label: "Show deleted data"
    },
    dialog: {
        add: {
            title: "Add a new profile",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    },
    table: {
        pageList: {
            ref_resource_types: "Administration page : Resource type repository",
            ref_ressources: "Administration page : Resource repository",
            ref_skills: "Administration page : Skills repository",
            ref_skill_levels: "Administration page : Skill level repository",
            ref_instructor_roles: "Administration page : Instructor roles repository",
            timetables: "Administration page : Timetable repository",
            ref_time_vacation: "Administration page : Guide for temporary assignments repository",
            ref_task_types: "Administration page : Session types repository",
            ref_prefixes: "Administration page : Training prefix and code repository",
            ref_training_product_states: "Administration page : Training product model states repository",
            ref_groups: "Administration page : Trainee groups repository",
            ref_time_code: "Administration page : Time codes repository",
            ref_plane_types: "Administration page : Plane types repository",
            ref_sites: "Administration page : Sites repository",
            ref_seasons: "Administration page : Seasons repository",
            ref_oraganizations: "Administration page : Airlines repository",
            ref_rules: "Administration page : Rules repository",
            ref_divisions: "Administration page : Divisions repository",
            ref_users_profiles: "Administration page : User profiles",
            export_page: "Administration page : Planning exports",
            versions: "Administration page : Application version tracking",
            flux: "Administration page : Application workflow execution",
            timeline: "Planning page : Timeline",
            training_product: "Planning page : Training products",
            training_course: "Planning page : Training courses",
            alert_dashboard: "Planning page : Alerts"
        },
        header: {
            page: "page",

            access: {
                read: "Read",
                deny: "Deny",
                write: "Write"
            }
        }
    },
    manageProfileButton: {
        label: "Assign the rights",
        tooltip: "Access the profile configuration modal"
    },
    tab: {
        profile: "Attributes",
        pages: {
            title: "Access rights to pages",
            column: {
                pageName: "Page name",
                pageAccess: "Access"
            }
        },
        data: {
            title: "Data access rights",
            column: {
                globalScopeName: "Scope",
                scopeAccess: "Access",
                scopeName: "Data name",
                defaultNoneAccess: "Access denied"
            }
        }
    },
    action: {
        profile: {
            add: "Creating one or more profiles - Profiles created:",
            update: "Modification of one or more profile(s) - Modified profile(s):",
            delete: "Modification of one or more profile(s) - Modified profile(s):"
        },
        pages: {
            add: "Access to application pages - creation of authorization for the following profile(s):",
            update: "Access to application pages - modification of permissions for the following profile(s):",
            delete: "Access to application pages - removal of authorization(s) for the following profile(s):"
        },
        data: {
            add: "Access to application data - creation of authorization for the following profile(s):",
            update: "Access to application data - modification of permissions for the following profile(s):",
            delete: "Access to application data - removal of authorization(s) for the following profile(s):"
        },
        full: {
            add: "Access to application data and pages - creation of authorization for the following profile(s):",
            update: "Access to application data and pages - modification of permissions for the following profile(s):",
            delete: "Access to application data and pages - removal of authorization(s) for the following profile(s):"
        }
    }
};


export const _fr = {
    addButton: {
        label: "Profil"
    },
    toggleDeleted: {
        label: "Afficher les profils archivés"
    },
    dialog: {
        add: {
            title: "Ajout d'un profil",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    },
    table: {
        pageList: {
            ref_resource_types: "Page d'administration : Référentiel des types de ressources",
            ref_ressources: "Page d'administration : Référentiel des ressources",
            ref_skills: "Page d'administration : Référentiel des compétences",
            ref_skill_levels: "Page d'administration : Référentiel des niveaux de compétences",
            ref_instructor_roles: "Page d'administration : Référentiel des rôles instructeurs",
            timetables: "Page d'administration : Référentiel des grilles horaires",
            ref_time_vacation: "Page d'administration : Référentiel des vacations",
            ref_task_types: "Page d'administration : Référentiel des activités",
            ref_prefixes: "Page d'administration : Référentiel des préfixes / codes de stage",
            ref_training_product_states: "Page d'administration : Référentiel des états de modèles de stage",
            ref_groups: "Page d'administration : Référentiel des groupes",
            ref_time_code: "Page d'administration : Référentiel des codes horaires",
            ref_plane_types: "Page d'administration : Référentiel des types avion",
            ref_sites: "Page d'administration : Référentiel des sites",
            ref_seasons: "Page d'administration : Référentiel des saisons",
            ref_oraganizations: "Page d'administration : Référentiel des compagnies",
            ref_rules: "Page d'administration : Référentiel des règles",
            ref_divisions: "Page d'administration : Référentiel des services",
            ref_users_profiles: "Page d'administration : Référentiel des profils utilisateurs",
            export_page: "Page d'administration : Export des plannings",
            versions: "Page d'administration : Suivi des versions applicatives",
            flux: "Page d'administration : Exécutions des flux applicatifs",
            timeline: "Page planning : Timeline",
            training_product: "Page planning : Modèles de stage",
            training_course: "Page planning : Stages",
            alert_dashboard: "Page planning : Alertes"
        },
        header: {
            page: "page",
            access: {
                read: "Lecture",
                deny: "Interdit",
                write: "Ecriture"
            }
        }
    },
    manageProfileButton: {
        label: "Attribuer les droits",
        tooltip: "Accéder à la modale de configuration des profils"
    },
    tab: {
        profile: "Attributs",
        pages: {
            title: "Droits d'accès aux pages",
            column: {
                pageName: "Nom de la page",
                pageAccess: "Accès"
            }
        },
        data: {
            title: "Droits d'accès aux données",
            column: {
                globalScopeName: "Périmètre",
                scopeAccess: "Accès",
                scopeName: "Nom de la donnée",
                defaultNoneAccess: "Accès refusé"
            }
        }
    },
    action: {
        profile: {
            add: "Création d'un ou de plusieurs profil(s) - Profils créé(s) : ",
            update: "Modification d'un ou de plusieurs profil(s) - Profils modifié(s) : ",
            delete: "Modification d'un ou de plusieurs profil(s) - Profils modifié(s) : "
        },
        pages: {
            add: "Accès aux pages de l'application - création d'habilitation pour le/les profil(s) suivant(s) : ",
            update: "Accès aux pages de l'application - modification d'habilitation pour le/les profil(s) suivant(s) : ",
            delete: "Accès aux pages de l'application - suppression d'habilitation(s) pour le/les profil(s) suivant(s) : "
        },
        data: {
            add: "Accès aux données de l'application - création d'habilitation pour le/les profil(s) suivant(s) : ",
            update: "Accès aux données de l'application - modification d'habilitation pour le/les profil(s) suivant(s) : ",
            delete: "Accès aux données de l'application - suppression d'habilitation(s) pour le/les profil(s) suivant(s) : "
        },
        full: {
            add: "Accès aux données et aux pages de l'application - création d'habilitation pour le/les profil(s) suivant(s) : ",
            update: "Accès aux données et aux pages de l'application - modification d'habilitation pour le/les profil(s) suivant(s) : ",
            delete: "Accès aux données et aux pages de l'application - suppression d'habilitation(s) pour le/les profil(s) suivant(s) : "
        }
    }
};